<template>
  <v-sheet>
    <div align="center">
      <v-card
        class="ma-2"
        :class="mobile ? 'mobilewindow' : 'mainwindow'"
      >
        <template #prepend>
          <div class="text-h5 text-accent pa-1">
            Songbook PDFs
          </div>
        </template>
        <div class="d-flex fill">
          <v-text-field
            v-model="search"
            label="Search for Artist or Song"
            prepend-inner-icon="fa-sharp-duotone fa-search"
            clearable
            @update:model-value="doSearch"
            @click:clear="showAll"
          />

          <v-icon-btn
            v-tooltip:bottom="'Show Indexed Only'"
            icon="fa-sharp-duotone fa-album-collection"
            :active="toggleIndex"
            @click="toggleIndex = !toggleIndex"
          />
          <v-icon-btn
            v-tooltip:bottom="'List Songbooks with Searched Song'"
            icon="fa-sharp-duotone fa-magnifying-glass-music"
            :active="toggleSongSearch"
            @click="toggleSongSearch = !toggleSongSearch"
          />
          <v-icon-btn
            v-tooltip:bottom="'Change Sorting Order'"
            :icon="
              sortOrder === 'asc'
                ? 'fa-sharp-duotone fa-arrow-down-a-z'
                : 'fa-sharp-duotone fa-arrow-down-z-a'
            "
            @click="changeOrder"
          />
        </div>

        <v-card
          v-if="search !== '' && toggleSongSearch"
          title="Song Found In:"
          density="compact"
          rounded="lg"
          variant="outlined"
          class="mb-3"
        >
          <v-list>
            <v-list-item
              v-for="(album, g) in files"
              :key="g"
              prepend-icon="fa-sharp-duotone fa-album"
              :title="album.name"
              @click="loadbook(files[g].url)"
            />
          </v-list>
        </v-card>

        <v-data-table
          v-model:sort-by="sortBy"
          hide-default-header
          :items="files"
          item-value="url"
          return-object
          :loading="appStore.loading"
          :height="getTableHeight"
        >
          <template #item="{ item }">
            <v-card
              :key="item.name"
              v-tooltip:bottom="item.url"
              density="compact"
              class="ma-1"
              color="primary"
            >
              <v-list-item>
                <template #title>
                  {{ parseTitle(item.name) }}
                </template>
                <template #append>
                  <div class="d-flex justify-self-end">
                    <v-btn
                      v-tooltip:bottom="'Album Tracks List'"
                      icon="fa-sharp-duotone fa-music"
                      size="xs"
                      class="ma-1"
                      color="primary"
                      :disabled="item.songs.length < 1"
                      @click="showlist(item.name, item.songs)"
                    />
                    <v-btn
                      v-tooltip:bottom="'Open Songbook'"
                      icon="fa-sharp-duotone fa-book-open"
                      size="xs"
                      class="ma-1"
                      @click="loadsong(item.url, 0)"
                    />
                    <v-btn
                      v-tooltip:bottom="'Download Songbook'"
                      icon="fa-sharp-duotone fa-file-pdf"
                      size="xs"
                      :href="item.url"
                      target="_new"
                      class="ma-1"
                      download
                    />
                  </div>
                </template>
              </v-list-item>
              <v-chip-group v-if="search !== ''">
                <v-chip
                  v-for="chip in showMatched(item.songs)"
                  :key="chip.title"
                >
                  {{ chip.title }}
                </v-chip>
              </v-chip-group>
            </v-card>
          </template>
        </v-data-table>
      </v-card>

      <v-dialog
        v-model="showAlbumTracks"
        transition="slide-x-reverse-transition"
      >
        <v-card
          class="pa-0"
          :class="mobile ? 'trackmobile' : 'trackpanel'"
        >
          <v-card-title class="bg-primary">
            <v-row>
              <span v-if="!mobile"> {{ parseTitle(albumName) }}</span>
              <v-spacer />
              <v-btn
                variant="text"
                icon="fa-sharp-duotone fa-circle-xmark"
                @click="showAlbumTracks = !showAlbumTracks"
              />
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-virtual-scroll
              :height="getHeight"
              :items="playlist"
            >
              <template #default="{ item }">
                <v-list-item
                  base-color="primary"
                  :title="item.title"
                  :active="titleMatch(item.title)"
                  @click="
                    loadsong(
                      `https://data.tdot.men/pdf/${albumName}.pdf`,
                      getIndex(item)
                    )
                  "
                >
                  <template #prepend>
                    <v-avatar>
                      {{ getIndex(item) }}
                    </v-avatar>
                  </template>

                <!-- <v-list-item-subtitle>
                    {{ item.destination }}
                  </v-list-item-subtitle> -->
                </v-list-item>
              </template>
            </v-virtual-scroll>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="showAlbumTracks = !showAlbumTracks">
              CLOSE
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--
    <v-footer
      class="text-center d-flex flex-column ga-2 py-4"
      color="indigo-lighten-1"
    >
      <div class="text-caption font-weight-regular opacity-60">
        This site, this web application as well as all contents available here
        are only for private use only. Any usage by the public is strictly
        prohibited.
      </div>
    </v-footer> -->
    </div>
  </v-sheet>
</template>

<script setup lang="ts">
import axios from "axios";
import { useRouter } from "vue-router";
import { ref, computed, onMounted, watchEffect } from "vue";
import { useAppStore } from "../stores/app";
import { useDisplay } from "vuetify";
import { type FileDetail, type Song } from "../components/Types";


const router = useRouter();
const { mobile } = useDisplay();

const appStore = useAppStore();
// const showDrawer = computed(() => {
//   return appStore.drawer;
// });
const toggleSongSearch = ref(false);
const toggleIndex = ref(false);
const showAlbumTracks = ref(false);
// const expand = ref(false);

const files = ref([] as FileDetail[]);
// const search = ref('');
const search = computed({
  get() {
  return appStore.currentSearch;
  },
  set(newVal) {
    appStore.currentSearch = newVal;
  }
})
// const url = ref("");
const sortOrder = ref("asc");

const sortBy = computed(() => {
  return [{ key: "name", order: sortOrder.value }];
});
const playlist = ref([] as Song[]);
const albumName = ref("");

const getHeight = computed(() => {
  return window.innerHeight - 200;
});

const getTableHeight = computed(() => {
  return window.innerHeight - 310;
});

function titleMatch(val: string) {
  if (search.value === '' || search.value === null) {
    return false;
  } else if (val.replace(/\s+/g, '').toLowerCase().includes(search.value.replace(/\s+/g, '').toLowerCase())) {
    return true;
  } else {
    return false;
  }
}

function changeOrder() {
  sortOrder.value === "asc"
    ? (sortOrder.value = "desc")
    : (sortOrder.value = "asc");
}

function parseTitle(book: string) {
  if (book.includes("-")) {
    return book.replace("-", " ").replace(/\B([A-Z])\B/g, " $1");
  } else {
    return book.replace(/\B([A-Z])\B/g, " $1");
  }
}

function getIndex(item: Song) {
  return playlist.value.indexOf(item) + 1;
}
// function toggleDrawer() {
//   if (appStore.drawer) {
//     appStore.drawer = false;
//   } else {
//     appStore.drawer = true;
//   }
// }

function showAll() {
  files.value = appStore.files;
  search.value = '';
}

function loadbook(book: string) {
  appStore.file = book;
  appStore.fileName = book
    .replace("https://data.tdot.men/pdf/", "")
    .replace(".pdf", "");
  appStore.currentPage = 1;
  // toggleDrawer();
  router.push({
    name: 'Viewer',
    params: {
      file: appStore.fileName
    }
  });
}

function loadsong(book: string, track: number) {
  appStore.file = book;
  appStore.fileName = book
    .replace("https://data.tdot.men/pdf/", "")
    .replace(".pdf", "");
  appStore.currentPage = 1;
  appStore.currentTrack = track;
  // toggleDrawer();
  router.push({
    name: 'Viewer',
    params: {
      file: appStore.fileName
    }
  });
}

function showIndexedOnly() {
  files.value = appStore.showIndexedOnly();
}

function doSearch() {
  if (search.value && search.value !== "") {
    files.value = appStore.find(search.value);
    appStore.currentSearch = search.value;
  }
}

function showlist(name: string, songs: Song[]) {
  playlist.value = songs;
  albumName.value = name;
  showAlbumTracks.value = true;
}

function showMatched(songs: Song[]) {
  const s = songs.filter(k => k.title.replace(/\s+/g, '').toLowerCase().includes(search.value.replace(/\s+/g, '').toLowerCase()))

  if (s) {
    return s
  }
}


watchEffect(() => {
  if (search.value === null || search.value === "") {
    files.value = appStore.files;
    toggleSongSearch.value = false;
    appStore.currentSearch = "";
  }

  if (toggleIndex.value === true) {
    showIndexedOnly();
  }

});

onMounted(async () => {
  appStore.loading = true;
  if (appStore.fileLength === 0) {
    // const newfiles: File[] = [];
    const data = await axios.get("https://data.tdot.men/pdf/filelist.json");

    const fileitems = data.data;

    appStore.saveFiles(fileitems);
    files.value = fileitems;
  } else {
    files.value = appStore.files;
  }

  doSearch();

  appStore.loading = false;

  // console.log(appStore.find("enjoy"));
});
</script>

<style lang="css" scoped>
  .mainwindow {
    width: 60vw;
    align-self: center;
box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;  }

  .mobilewindow {
    width: 95vw;
    align-self: center;

box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
  }

  .trackpanel {
    align-self: center;
    width: 60vw;
    background-color: #ffffff;
    box-shadow: rgba(3, 102, 214, 0.3) 0px 0px 0px 3px;    /* box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px; */
}

 .trackmobile {
    align-self: center;
    width: 95vw;
    background-color: #ffffff;
    box-shadow: rgba(3, 102, 214, 0.3) 0px 0px 0px 3px;    /* box-shadow: rgba(136, 165, 191, 0.48) 6px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px; */
}
</style>
